import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  IconButton,
  Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";

import {
  getExpenseAdvances,
  createExpenseAdvance,
  updateExpenseAdvance,
  deleteExpenseAdvance,
} from "../../../../api/Expenses/expenseAdvancesApi";

const ExpenseAdvancesTab = ({ documentId, isLocked, onRefreshSummary }) => {
  const [advances, setAdvances] = useState([]);

  // 🔒 Documento bloqueado

  const loadAdvances = async () => {
    const data = await getExpenseAdvances(documentId);
    setAdvances(data);
  };

  useEffect(() => {
    loadAdvances();
  }, [documentId]);

  // ➕ Añadir anticipo
  const handleAdd = async () => {
    if (isLocked) return;

    await createExpenseAdvance({
      ExpenseDocumentId: documentId,
      AdvanceDate: new Date(),
      Concept: "Anticipo",
      Amount: 0,
      Currency: "EUR",
      ExchangeRate: 1,
      AmountEUR: 0,
    });

    await loadAdvances();
    onRefreshSummary?.();
  };

  // ✏️ Actualizar anticipo
  const handleUpdate = async (id, data) => {
    if (isLocked) return;

    await updateExpenseAdvance(id, data);
    await loadAdvances();
    onRefreshSummary?.();
  };

  // 🗑 Eliminar anticipo
  const handleDelete = async (id) => {
    if (isLocked) return;

    await deleteExpenseAdvance(id);
    await loadAdvances();
    onRefreshSummary?.();
  };

  return (
    <Box>
      {/* ➕ Añadir */}
      <Button
        variant="contained"
        onClick={handleAdd}
        sx={{ mb: 2 }}
        disabled={isLocked}
      >
        Añadir anticipo
      </Button>

      {advances.map((adv) => (
        <Paper key={adv.id} sx={{ p: 2, mb: 1 }}>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            {/* 📅 Fecha */}
            <TextField
              type="date"
              size="small"
              defaultValue={dayjs(adv.AdvanceDate).format("YYYY-MM-DD")}
              disabled={isLocked}
              onBlur={(e) =>
                handleUpdate(adv.id, {
                  AdvanceDate: e.target.value,
                })
              }
            />

            {/* 📝 Concepto */}
            <TextField
              size="small"
              label="Concepto"
              defaultValue={adv.Concept}
              disabled={isLocked}
              onBlur={(e) =>
                handleUpdate(adv.id, {
                  Concept: e.target.value,
                })
              }
              sx={{ flex: 1 }}
            />

            {/* 💶 Importe */}
            <TextField
              size="small"
              type="number"
              label="€"
              defaultValue={adv.AmountEUR}
              disabled={isLocked}
              onBlur={(e) => {
                const value = Number(e.target.value || 0);
                handleUpdate(adv.id, {
                  Amount: value,
                  AmountEUR: value,
                });
              }}
              sx={{ width: 120 }}
            />

            {/* 🗑 Eliminar */}
            <IconButton
              color="error"
              onClick={() => handleDelete(adv.id)}
              disabled={isLocked}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default ExpenseAdvancesTab;
